import "../../../css/landscape-warning.css";

export const LandscapeWarning = ()=>{
    return <div className="landscape-warning-base">
        <div className="warning-text">
        Keep your device portrait to play Animaverse!
        </div>
    </div>
}